import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class AuditEventService extends Service {
    constructor() {
        super();
        this.baseURL = 'auditEvent';
    }

    findByEntityNameAndEntityId(entityName, entityId) {
        return fetch(SERVER_URL + this.baseURL + '/findByEntityNameAndEntityId/' + entityName + '/' + entityId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findEventByEntityNameAndEntityId(entityName, entityId) {
        return fetch(SERVER_URL + this.baseURL + '/findEventByEntityNameAndEntityId/' + entityName + '/' + entityId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}